
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]/register",
      function () {
        return require("private-next-pages/event/[eventId]/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[eventId]/register"])
      });
    }
  